<template>
  <div class="view contentBody">
    <div class="condition">
      <div class="check_wrap">
        <el-radio-group v-model="listForm.time_type" @change="radioChange" size="small">
          <el-radio-button label="0">汇总</el-radio-button>
          <el-radio-button label="1">今日</el-radio-button>
          <el-radio-button label="2">本月</el-radio-button>
          <el-radio-button label="3">本年</el-radio-button>
        </el-radio-group>
      </div>
      <div class="search_wrap">
        <el-form :inline="true" :model="listForm" class="form-inline">
         <el-form-item label="创建时间">
          <el-date-picker class="mr10"
            v-model="createDateTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            size="medium"
           >
          </el-date-picker>
        </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="searchFn" size="small"></el-button>
          </el-form-item>
        </el-form>
      </div>
      <p class="materialword mb-10 mt20"></p>
    </div>
    <div class="table_wrap">
      <div class="summary_body partner_summary_body">
        <div class="summary_body_list">
            <!--<i class="iconfont iconbangzhu"></i>-->
            <span class="summary_body_list_span" >股东人数</span>
            <p class="summary_body_list_p cor00"><span>{{count_data.partner_total}}</span>人</p>
            <p class="summary_body_list_p">内部股东 {{count_data.partner_inside}}人/外部股东{{count_data.partner_outside}}人</p>

          </div>
          <div class="summary_body_list">
            <!--<i class="iconfont iconbangzhu"></i>-->
            <span class="summary_body_list_span">带动营业额</span>
            <p class="summary_body_list_p cor00">￥<span>{{count_data.money_total}}</span></p>
            <p class="summary_body_list_p">内部股东￥{{count_data.money_inside}}/外部股东￥{{count_data.money_outside}}</p>
          </div>
          <div class="summary_body_list">
            <!--<i class="iconfont iconbangzhu"></i>-->
            <span class="summary_body_list_span">成单客源</span>
            <p class="summary_body_list_p cor00"><span>{{count_data.customer_total}}</span>人</p>
            <p class="summary_body_list_p">内部股东{{count_data.customer_inside}}人/外部股东{{count_data.customer_outside}}人/手动录入{{count_data.customer_manual}}人</p>
          </div>
      </div>
      <el-table :data="articleList" style="width: 100%">
        <el-table-column prop="name" label="股东姓名" width="260"></el-table-column>
        <el-table-column prop="tel" label="联系方式"></el-table-column>
        <el-table-column label="股东类型" prop="type_text">
          <!-- <template slot-scope="scope">
            <span v-if="scope.row.type_text==1">外部合伙人</span>
            <span v-if="scope.row.type_text==2">内部合伙人</span>
          </template> -->
        </el-table-column>
        <el-table-column prop="total_money" label="带动营业额">
          <template slot-scope="scope">
            <span v-if="scope.row.total_money">{{scope.row.total_money}}</span>
            <span v-else>0.00</span>
          </template>
        </el-table-column>
        <el-table-column prop="total_customer" label="成单客源"></el-table-column>
        <el-table-column prop="create_time_text" label="创建时间"></el-table-column>
        <el-table-column prop="commission" label="佣金余额"></el-table-column>
      </el-table>
      <div class="pag_wrap">
        <el-pagination
              background
              @current-change="pageIndexChange"
              :page-size="page.page_size"
              :current-page="page.current_page"
              layout="total, prev, pager, next"
              :total="page.total_rows"></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
  import api from "@/api.js";
  import {yeartime} from '@/assets/js/common'
  import {pagination} from "@/util/util.js";

  export default {
    name: "summary",
    data() {
      return {
        listForm: {
          time_type: 0,
          start_time: '',
          end_time: '',
          page:1,
        },
        articleList: [],
        createDateTime: [],
        page: {
        current_page: pagination.pageIndex,
        page_size: pagination.pageSize,
        total_rows: pagination.total
      },
      count_data:'',
      // pickerOptions: {
		  //     disabledDate(time) {
		  //       return time.getTime() > Date.now(); // - 8.64e7 减去就是不包含今天的
			//   	},
			// 		shortcuts: [
			// 			{
			// 				text: '今天',
			// 				onClick(picker) {
			// 					picker.$emit('pick', new Date());
			// 				}
			// 			},{
			// 				text: '昨天',
			// 				onClick(picker) {
			// 					const date = new Date();
			// 					date.setTime(date.getTime() - 3600 * 1000 * 24);
			// 					picker.$emit('pick', date);
			// 				}
			// 			},{
			// 				text: '一周前',
			// 				onClick(picker) {
			// 					const date = new Date();
			// 					date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
			// 					picker.$emit('pick', date);
			// 				}
			// 			}
			// 		]
			// 	}
      };
    },
    created() {
      const loading = this.$loading({
        lock: true,
        text: '加载中…',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.4)',
          customClass:'fontColor'
      });
      this.InitFn(loading)
    },
    methods: {
      InitFn(loading) {
        // 创建执行
        this.listForm.page = this.page.current_page
        if (this.createDateTime && this.createDateTime.length > 0) {
		      this.listForm.start_time = this.createDateTime[0]
					this.listForm.end_time = this.createDateTime[1]
				} else {
					this.listForm.start_time = ""
					this.listForm.end_time = ""
				}
        this.axios
            .post(api.partner_index, this.listForm)
            .then(response => {
              if (response.data.code == 0) {
                for (let i in response.data.result.list) {
                  response.data.result.list[i].start_time = yeartime(response.data.result.list[i].start_time)
                }
                this.articleList = response.data.result.list
                this.count_data = response.data.result.count_data
                this.page = response.data.page
                this.page.total_rows = response.data.page.cur_rows
                loading.close();
              } else {
              }
            })
            .catch(response => {
            });
      },
      pageIndexChange(pageindex) {
      this.listForm.page = pageindex;
      this.initFn();
    },
      radioChange(option) {
        // 选择radio
        this.listForm.time_type = option
        this.page.total = 1
        this.InitFn()
      },
      searchFn() {
        this.listForm.page = 1
        this.InitFn()
      },
      
    }
  };
</script>
